export default __webpack_public_path__ + "static/media/gallery_02.b79b4dda.jpg";